<template>
  <div>
    <input
      type="time"
      v-model="time"
      :step="step"
      class="time-field"
      :disabled="loading || disabled"
      :class="errorMessages.length ? 'is_error' : ''"
      @input="handleInput"
    />
  </div>
</template>

<script>
export default {
  name: 'TimePicker',
  props: {
    value: {
      type: [Date, String],
      default: new Date()
    },
    step: {
      type: [Number, String],
      default: 0
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      time: this.value
    }
  },
  watch: {
    value (value) {
      this.time = value
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', this.time)
    }
  }
}
</script>
<style>
.time-field {
  width: 150px;
  border: solid 1px #9e9e9e;
  border-radius: 4px;
  padding: 15px;
  font-size: 16px;
  margin-bottom: 10px;
}
.is_error{
  border: 2px solid #ff5252;
  color: #ff5252 ;
}
.v-application.theme--dark .time-field {
  color: #ffffff
}
.v-application.theme--dark .time-field.is_error {
  color: #ff5252
}
.v-application.theme--dark .time-field::-webkit-calendar-picker-indicator{
  filter: invert(1);
}
</style>
